import { useSelector } from "react-redux";
import { Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { KeyboardArrowRightOutlined } from "@mui/icons-material";
import { btc, lnurl, payVia, payViaSubMsg, sats, XAUT } from "./messages";
import Text from "./text/Text";
import { walletIconBlue } from "./images";
import {
  btcToSatsAmount,
  displayAmountWithCurrency,
  displaySelectedCurrencyAmount,
  getAmountFormatted,
  getCurrencyAmount,
  getExchangeRate,
  payRequest,
  satsToBtcAmount,
} from "./constants";

function CommonPayViaModalContent({
  setIsPayViaOpen,
  paymentMethods,
  balanceData,
  setBalance,
  withdrawData: data,
  setButtonLoader,
  currency,
  setCurrency,
  amount,
  setAmount,
  minTransactionAmt,
  maxTransactionAmt,
  setMinTransactionAmt,
  setMaxTransactionAmt,
  isShowHeading = false,
}) {
  const showBtcAmount = useSelector((state) => state.common.showBtcAmount);

  const isLnUrlMethodSend =
    data?.withdraw_method === lnurl && data?.tag === payRequest;

  const handleMinMaxLimits = (targetCurrency, currencyExchangeRate) => {
    let minAmount =
      targetCurrency === sats
        ? data?.min_sendable
        : minTransactionAmt * currencyExchangeRate;

    let maxAmount =
      targetCurrency === sats
        ? data?.max_sendable
        : maxTransactionAmt * currencyExchangeRate;

    setMinTransactionAmt?.(minAmount);
    setMaxTransactionAmt?.(maxAmount);
  };

  const handleSendDataChange = (
    isFixedAmtSats,
    currency,
    targetCurrency,
    currencyExchangeRate
  ) => {
    const satsToFixedAmount = showBtcAmount ? 8 : 0;
    const toFixedAmt =
      targetCurrency === sats
        ? satsToFixedAmount
        : targetCurrency === XAUT
        ? 6
        : 2;
    let targetCurrencyAmt = amount;

    if (isFixedAmtSats) {
      targetCurrencyAmt = displaySelectedCurrencyAmount(data?.amount);
    } else {
      //convert btc amt to sats for exchange if amt is in btc
      targetCurrencyAmt =
        showBtcAmount && currency === sats
          ? btcToSatsAmount(targetCurrencyAmt)
          : targetCurrencyAmt;

      targetCurrencyAmt = targetCurrencyAmt * currencyExchangeRate;

      //convert sats amt to btc if showBtc is enabled
      targetCurrencyAmt =
        showBtcAmount && targetCurrency === sats
          ? satsToBtcAmount(targetCurrencyAmt)
          : targetCurrencyAmt;

      targetCurrencyAmt = targetCurrencyAmt.toFixed(toFixedAmt);
    }

    const targetedBalance = balanceData.find(
      (bal) => bal.target_currency === targetCurrency
    );

    setAmount(Number(targetCurrencyAmt));
    setBalance(getCurrencyAmount(targetedBalance?.amount, targetCurrency) || 0);
  };

  const handleChangePaymentMethod = async (targetCurrency) => {
    setButtonLoader(targetCurrency !== currency);
    const isFixedAmtSats = targetCurrency === sats && data?.amount;
    let currencyExchangeRate = 1;

    if (targetCurrency !== currency && !isFixedAmtSats) {
      const res = await getExchangeRate(currency, targetCurrency);
      currencyExchangeRate = res?.target_lowest_rate;
    }

    handleSendDataChange(
      isFixedAmtSats,
      currency,
      targetCurrency,
      currencyExchangeRate
    );
    isLnUrlMethodSend &&
      handleMinMaxLimits?.(targetCurrency, currencyExchangeRate);

    setCurrency(targetCurrency);
  };

  const displayAmount = (balanceAmt, currency) => {
    if (balanceAmt) {
      let amount = getCurrencyAmount(balanceAmt, currency);
      if (showBtcAmount && currency === sats) {
        currency = btc;
      } else {
        amount = getAmountFormatted(amount, currency);
      }

      return displayAmountWithCurrency(currency, amount);
    } else {
      return 0;
    }
  };

  return (
    <Box className="pay-via-container">
      {isShowHeading && (
        <Box className="pay-via-drawer-header">
          <Text font="bold" size={20} className="default-text">
            {payVia}{" "}
          </Text>
          <CloseIcon
            sx={{
              color: "#848B9E",
              height: "24px",
              width: "24px",
              cursor: "pointer",
            }}
            onClick={() => setIsPayViaOpen(false)}
          />
        </Box>
      )}
      <Text
        className="grey-text"
        font="regular"
        size={14}
        sx={{ marginBottom: "20px" }}
      >
        {payViaSubMsg}{" "}
      </Text>
      {paymentMethods.map((targetCurrency) => {
        const targetCurrencyBalance = targetCurrency.balance;
        const targetCurrencyName = targetCurrency.name;
        return (
          <Box
            className="mode-box"
            onClick={(e) => {
              handleChangePaymentMethod(targetCurrency.name);
              setIsPayViaOpen(false);
            }}
            key={targetCurrency.name}
          >
            <Box display="flex" alignItems="center" gap={1}>
              <img
                src={walletIconBlue}
                height={20}
                width={20}
                alt="wallet icon"
              />
              <Text className="default-text" font="semibold" size={16}>
                {targetCurrencyName === sats ? btc : targetCurrencyName}
              </Text>
            </Box>
            <Box display="flex" alignItems="center">
              <Text className="blue-text" font="bold" size={16}>
                {displayAmount(targetCurrencyBalance, targetCurrencyName)}
              </Text>
              <KeyboardArrowRightOutlined
                sx={{
                  color: "#848B9E",
                }}
              />
            </Box>
          </Box>
        );
      })}
    </Box>
  );
}

export default CommonPayViaModalContent;
